<script>
  import Lightbox from '$lib/lightbox/Index.svelte';
  export let title;
  export let images;

  let lightbox = {
    type: 'gallery',
    gallery: images,
  };

  let openLightbox;
  function handleOpenClick(index) {
    openLightbox(index);
  }
</script>

<section class="gallery">
  <p class="gallery__title tagline">{title}</p>
  <div class="gallery__grid flexbox">
    {#each images as image, index}
      <div class="col col-33 col-m-50 col-s-full">
        <div class="gallery__image-wrap">
          <div
            class="gallery__image"
            on:click={() => {
              handleOpenClick(index);
            }}
          >
            <img
              src={image.src}
              width={image.width}
              height={image.height}
              alt={image.alt}
              loading="lazy"
            />
          </div>
          {#if image.caption}
            <p class="gallery__image-caption text-micro">
              {image.caption}
            </p>
          {/if}
        </div>
      </div>
    {/each}
  </div>
</section>

<Lightbox {lightbox} bind:open={openLightbox} />

<style lang="scss">
  .gallery {
    padding: 8rem 0;
    border-top: 1px solid $light-border;

    &__title {
      text-align: center;
      color: var(--royal-light);
    }

    &__grid.flexbox {
      row-gap: 2rem;
      margin: 4rem -1rem 1rem;

      & > .col {
        padding: 0 1rem;
      }
    }

    &__image-wrap {
      border: 1px solid $light-border;
      border-radius: 5px;
      padding: 2rem;
      display: flex;
      flex-direction: column;
      transition: all 0.3s;
    }

    &__image {
      aspect-ratio: 3/2.2;
      overflow: hidden;
      cursor: pointer;

      img {
        object-fit: cover;
        height: 100%;
        width: 100%;
      }

      &-caption {
        margin-top: 2rem;
        color: var(--royal-light);
      }
    }
  }
</style>
